import { isApiError, getFieldErrors, DEFAULT_ERROR_MESSAGE } from '@/services/api';

/** Normalised journey error: branch UI on `code`, never on `message`. */
export interface SmriqJourneyError {
    code: string;
    message: string;
    param?: string;
    fieldErrors?: Record<string, string[]>;
    retryAfterSeconds?: number;
}

const RETRY_AFTER_HEADER = 'retry-after';

function retryAfterSeconds(error: unknown): number | undefined {
    if (!isApiError(error) || error.status !== 429) return undefined;
    const headers = error.response?.headers as Record<string, unknown> | undefined;
    const raw = headers?.[RETRY_AFTER_HEADER];
    const parsed = typeof raw === 'string' || typeof raw === 'number' ? Number(raw) : NaN;
    return Number.isFinite(parsed) ? parsed : undefined;
}

// The interceptor normalises code/message/param onto the rejected ApiError;
// getFieldErrors is the only sanctioned reader of the 422 field map.
export function toJourneyError(error: unknown): SmriqJourneyError {
    if (!isApiError(error)) {
        return { code: 'unknown', message: DEFAULT_ERROR_MESSAGE };
    }

    const fieldErrors = getFieldErrors(error);

    return {
        code: error.code ?? 'unknown',
        message: error.message || DEFAULT_ERROR_MESSAGE,
        param: error.param,
        fieldErrors: Object.keys(fieldErrors).length > 0 ? fieldErrors : undefined,
        retryAfterSeconds: retryAfterSeconds(error),
    };
}
